import device from "current-device";
import React, { Component } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { RouterProps } from "react-router";
import { analyticsFEA } from "src/AnalyticsFEA";
import { trimToJustDate } from "src/components/ContinueDeal/ScheduleAppointment/lib";
import WaityButton from "src/components/UserAccount/shared/WaityButton";
import { Appointment } from "Types/api/Appointment";
import OSDatepicker from "../../shared/Datepicker";
import OSTimepicker from "../../shared/Timepicker";
import "./ScheduleAppointment.scss";

interface ScheduleAppointmentProps extends RouterProps {
    setDate: (date: Date | undefined) => void;
    setTime: (time: Appointment["time"] | undefined) => void;
    schedule: () => Promise<any>;
    onScheduleSuccess: () => void;
    selectedDate: Date;
    selectedTime: undefined | Appointment["time"];
    errorMessage: string | null;
}

class ScheduleAppointment extends Component<ScheduleAppointmentProps & WithTranslation> {
    public render() {
        const { errorMessage, onScheduleSuccess, schedule, selectedDate, selectedTime, t } = this.props;
        return (
            <div className="ScheduleAppointment">
                <label className="ScheduleAppointment__label">{t("ContinueDeal.ScheduleAppointment.title")}</label>
                <div className="ScheduleAppointment__pickers">
                    <OSDatepicker
                        selectedDate={selectedDate}
                        reportUp={this.updateDate}
                        placeholderText={t("ContinueDeal.ScheduleAppointment.datepickerPlaceholder")}
                        minDate={new Date()}
                        inputDisabled={device.mobile()}
                    />{" "}
                    <OSTimepicker
                        reportUp={this.updateTime}
                        placeholderText={t("ContinueDeal.ScheduleAppointment.timePickerPlaceholder")}
                        value={selectedTime}
                    />
                </div>
                {errorMessage && <div className="error">{errorMessage}</div>}
                <div className="ScheduleAppointment__submit">
                    <WaityButton
                        text={t("ContinueDeal.ScheduleAppointment.scheduleButtonLabel")}
                        onClick={schedule}
                        onSuccess={onScheduleSuccess}
                    />
                </div>
            </div>
        );
    }

    private updateDate = (date: Date | undefined) => {
        if (date) {
            analyticsFEA.engine.pickDeliveryDate(trimToJustDate(date));
        }
        this.props.setDate(date);
    };

    private updateTime = (time: Appointment["time"]) => {
        analyticsFEA.engine.pickDeliveryTime(time);
        this.props.setTime(time);
    };
}

export default withTranslation()(ScheduleAppointment);
